<template>
  <div>
    <div>
      <b-modal ref="dcModalRef" id="deal-catalog-modal" header-bg-variant="info" header-text-variant="white" centered hide-footer no-fade size="lg" title="Deal catalog">
        <deal-catalog :shownTypes="shownTypes" :path="path" :isModal="true"/>
      </b-modal>
    </div>
    <b-card v-if="this.validDeal" no-body class="mb-1">
      <b-card-header header-tag="header" class="p-0 mt-1">
        <b-btn block href="#" v-b-toggle.dealInformation variant="info" class="text-left">{{ this.dealName }} - {{ this.type.toUpperCase() }} Analysis</b-btn>
      </b-card-header>
      <b-collapse id="dealInformation" visible>
        <b-card-body>
          <div v-if="activityMonth">
            <b-row>
              <b-col cols="4">
                <table class="table table-sm color mb-2">
                  <caption class="caption table-caption mb-2">Calculation Settings</caption>

                  <b-form-group label-cols="6" label-cols-lg="4" label="Credit model" label-for="ppay_model" class="text-left mb-0">
                    <b-input-group>
                      <b-form-select id="ppay_model" v-model="prepaymentModel" @change="onPrepaymentModelChanged">
                        <option :value="null">None</option>
                        <option value="LDM" v-if="this.$store.getters.isLDMUser">LDM 2.2</option>
                        <option value="LDM_3" v-if="this.$store.getters.isLDMUser">LDM 3.0</option>
                        <option value="AFT" v-if="this.$store.getters.isAFTUser">AFT</option>
                      </b-form-select>
                      <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" disabled>
                        <template slot="button-content"><i class="fas fa-sort-down transparent"></i></template>
                      </b-dropdown>
                    </b-input-group>
                  </b-form-group>

                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'CPR'"
                    :isDisabled="selectedScenario != null" type="CPR" :model="cpr" id="input-cpr"
                    :vectors="this.vectors" @CPRVectorChange='(data) => { cpr = data; emit("cprChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'CDR'"
                    :isDisabled="selectedScenario != null" type="CDR" :model="cdr" id="cdrInput"
                    :vectors="this.vectors" @CDRVectorChange='(data) => { cdr = data; emit("cdrChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'LossSeverity'"
                    :isDisabled="selectedScenario != null" type="LossSeverity" :model="lossSeverity" id="severityInput"
                    :vectors="this.vectors" @LossSeverityVectorChange='(data) => { lossSeverity = data; emit("lossSeverityChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'Delinquency'" :unit="null"
                    :isDisabled="selectedScenario != null" type="Delinquency" :model="delinquency" id="dlqInput"
                    :vectors="this.vectors" @DelinquencyVectorChange='(data) => { delinquency = data; emit("delinquencyChange", data)}' showHeader="true"
                  />

                  <!-- LDM LDM_3 -->
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    :name=" 'HPI'"
                    :isDisabled="selectedScenario != null" type="HPI"
                    :model="hpi"
                    id="input-cpr"
                    :vectors="this.vectors"
                    @HPIVectorChange='(data) => { hpi = data; emit("hpiChange", data)}'
                    showHeader="true"
                  />

                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel == 'LDM_3'"
                    name=" Unemployment"
                    :isDisabled="selectedScenario != null"
                    type="NationalUnemploymentForecast"
                    :model="NationalUnemploymentForecast"
                    id="input-NationalUnemploymentForecast"
                    :vectors="this.vectors"
                    @NationalUnemploymentForecastVectorChange='(data) => { NationalUnemploymentForecast = data; emit("NationalUnemploymentForecastChange", data)}'
                    showHeader="true"
                  />

                  <!-- ADCO -->
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" name="2Yr TSY"
                    :isDisabled="selectedScenario != null" type="2YrTsy" :model="twoYrTsy" id="cdrInput"
                    :vectors="this.vectors" @2YrTsyVectorChange='(data) => { twoYrTsy = data; emit("2YrTsyChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" name="10Yr TSY"
                    :isDisabled="selectedScenario != null" type="10YrTsy" :model="tenYrTsy" id="severityInput"
                    :vectors="this.vectors" @10YrTsyVectorChange='(data) => { tenYrTsy = data; emit("10YrTsyChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" :name="'Tune CPR'"
                    :unit="''" :isDisabled="selectedScenario != null" type="TuneCpr" :model="tuneCpr" id="dlqInput"
                    :vectors="new Map()" @TuneCprVectorChange='(data) => { tuneCpr = data; emit("tuneCprChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" name="Tune CDR"
                    type="TuneCdr" :model="tuneCdr" :unit="''" :isDisabled="selectedScenario != null"
                    :vectors="new Map()" @TuneCdrVectorChange='(data) => { tuneCdr = data; emit("tuneCdrChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" name="Tune Severity" type="TuneSeverity"
                    :model="tuneSeverity" :unit="''" :isDisabled="selectedScenario != null" :vectors="new Map()"
                    @TuneSeverityVectorChange='(data) => { tuneSeverity = data; emit("tuneSeverityChange", data)}' showHeader="true"
                  />

                  <!-- AFT -->
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == 'AFT'" :name=" 'HPA'"
                    :isDisabled="selectedScenario != null" type="HPA" :model="hpa" id="input-hpa"
                    :vectors="this.vectors" @HPAVectorChange='(data) => { hpa = data; emit("hpaChange", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == 'AFT'" name="15Yr MTG"
                    :isDisabled="selectedScenario != null" type="15YrMtg" :model="mtg15" id="severityInput"
                    :vectors="this.vectors" @15YrMtgVectorChange='(data) => { mtg15 = data; emit("mtg15Change", data)}' showHeader="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == 'AFT'" name="30Yr MTG"
                    :isDisabled="selectedScenario != null" type="30YrMtg" :model="mtg30" id="severityInput"
                    :vectors="this.vectors" @30YrMtgVectorChange='(data) => { mtg30 = data; emit("mtg30Change", data)}' showHeader="true"
                  />

                  <b-form-group label-cols="6" label-cols-lg="4" label="Scenario" label-for="scenario_select" class="text-left mb-0">
                    <b-input-group class="flex-no-wrap">
                      <b-form-input id="scenario_select" class="text-left cursor-pointer" v-model="cSelectedScenarioName" @click="flagModalScenarioPickerVisible = true"
                                    style="font-size: .8em !important;"></b-form-input>
                      <b-btn v-if="cFlagScenarioSelected" variant="link" class="dropdown-toggle toggle-class p-0 ml-1">
                        <i class="fas fa-times" @click="pickerOk(null)" style="font-size: 0.9rem !important; transform: translateY(-2px);"></i>
                      </b-btn>
                      <b-btn v-if="!cFlagScenarioSelected" variant="link" class="dropdown-toggle toggle-class p-0 ml-1">
                        <i class="fas fa-sort-down" @click="flagModalScenarioPickerVisible = true"></i>
                      </b-btn>
                    </b-input-group>
                  </b-form-group>
                  <b-modal
                    v-model="flagModalScenarioPickerVisible"
                    ok-variant="primary"
                    :scrollable="false"
                    :centered="true"
                    :hide-header="true"
                    :hide-footer="true"
                    size="scenarios"
                  >
                    <scenario
                      :flagAsScenarioPicker="true"
                      :pSelectedDealName="dealName"
                      @pickerOk="pickerOk"
                      @pickerCancel="flagModalScenarioPickerVisible = false"
                    />
                  </b-modal>

                  <b-form-group label-cols="6" label-cols-lg="4" label="Cancellation" label-for="chkbox_cancellation" class="text-left mb-0">
                    <b-input-group class="flex-no-wrap">
                      <template slot="label">
                      </template>
                      <b-form-checkbox
                        name="chkbox_cancellation"
                        v-model="cancel"
                        :disabled="selectedScenario != null && selectedScenario.type == 'cashflow'"
                        @change="onCancellationChangeEmit"
                        class="text-left"
                      ></b-form-checkbox>
                      <b-input-group v-if="cancel" class="flex-no-wrap">
                        <datepicker
                          :disabled="!cancel"
                          :clearable="false"
                          input-class="form-control text-right calculation-settings-input"
                          type="month"
                          format="MM/YYYY"
                          lang="en"
                          @change='onCancellationDateChangeEmit'
                          v-model="cancellationDateAsDate"
                          :default-date="cancellationDate.toDate()"
                          :disabled-date="isDisabledCancellationDate"
                        />
                        <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" disabled>
                          <template slot="button-content"><i class="fas fa-sort-down transparent"></i></template>
                        </b-dropdown>
                      </b-input-group>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group label-cols="6" label-cols-lg="4" label="Use Loan Level" label-for="chkbox_useLoanLevel" class="text-left mb-0">
                    <b-input-group class="flex-no-wrap">
                      <b-form-checkbox
                        name="chkbox_useLoanLevel"
                        v-if="(this.$store.getters.isLDMUser || this.$store.getters.isAFTUser) && !dealName.startsWith('BELL')"
                        v-model="useLoanLevel"
                        :disabled="selectedScenario != null && selectedScenario.type == 'cashflow'"
                        @change="onUseLoanLevelChanged($event)"
                        class="text-left"
                      ></b-form-checkbox>
                    </b-input-group>
                  </b-form-group>
                </table>
                <b-row>
                  <b-alert v-if="this.inputErrorMsg" variant="danger" class="float-left" show>{{ this.inputErrorMsg }}</b-alert>
                </b-row>
              </b-col>
              <b-col cols="4">
                <b-row class="text-left">
                  <b-col>
                    <table class="table table-sm color no-border">
                      <tbody>
                      <tr>
                        <th class="text-left font-weight-normal">Deal Name:</th>
                        <td class="text-right">
                          <h5 class="mb-0">
                            <a href="#" v-b-modal.deal-catalog-modal class="no-focus" @change='emit("dealNameChange", dealName)'>{{ this.dealName }} </a>
                            <router-link v-if="isOnlineDealsCreationAllowed && this.dealInfo.DealId != null" :to="{path:'deal_create', query: {dealType: this.dealInfo.DealType, dealId : this.dealInfo.DealId}}">
                              <i class="fas fa-edit"/>
                            </router-link>
                            <router-link v-if="isOnlineDealsCreationAllowed" :to="{path:'deal_create', query: {dealType: this.dealInfo.DealType}}">
                              <i class="fas fa-plus"/>
                            </router-link>
                          </h5>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left font-weight-normal">Activity Month:</th>
                        <td>
                          <select class="form-control custom-select" @change='emit("activityMonthChange", activityMonth)' v-model="activityMonth" :disabled="activityMonths.length == 0">
                            <option v-for="date in activityMonths" v-bind:key=date>{{ date }}</option>
                          </select>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <deal-information
                      :issueDate="this.dealInfo.IssueDate"
                      :optionalCancellationDate="this.dealInfo.OptionalCancellationDate"
                      :maturityDate="this.dealInfo.MaturityDate"
                    />
                  </b-col>
                </b-row>
                <div class="text-right mt-3">
                  <b-btn v-if="report1.pLabelRunButton.length > 0"
                         @click="()=>{this.report1_triggerRunReport = !this.report1_triggerRunReport}"
                         variant="primary">{{ report1.pLabelRunButton }}
                  </b-btn>
                </div>
              </b-col>
              <b-col cols="4">
                <collateral-information
                  :type="'Pool'"
                  :originalBalance="this.collateralInfo.OriginalBalance"
                  :currentBalance="this.collateralInfo.CurrentBalance"
                  :dealFactor="this.collateralInfo.DealFactor"
                  :WAC="this.collateralInfo.WAC"
                  :WAM="this.collateralInfo.WAM"
                  :WALA="this.collateralInfo.WALA"
                  :projectedLosses="this.collateralInfo.CollateralLosses"
                />
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-4 border-0">
      <b-card-header header-tag="header" class="p-0 mt-1" header-text-variant="white" v-if="report1_reportData && report1_reportData.length > 0">
        <b-btn block href="#" v-b-toggle.report1 variant="primary" class="text-left">{{ report1.pReportName }}</b-btn>
      </b-card-header>
      <b-collapse id="report1" visible>
        <b-row class="no-gutters">
          <b-col>
            <reportSingleExecutor
              :pReportName="report1.pReportName"
              :pReportParams="report1.pReportParams"
              :triggerRunReport="report1_triggerRunReport"
              :flagShowOwnRunButton="report1.flagShowOwnRunButton"
              :pLabelRunButton="report1.pLabelRunButton"
              @onReportDataReceived="(reportData)=>{this.report1_reportData = reportData; return reportData;}"
            />
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import service                                  from '@/services/HttpRequestService';
import formatter                                from '@/utilities/Formatter';
import moment                                   from 'moment';
import Datepicker                               from 'vue2-datepicker';
import DealCatalog                              from '../dealCatalog';
import CollateralInformation                    from '../dealInformation/CollateralInformation';
import DealInformation                          from './cirt_deal_information';
import CalculationSettingsInput                 from '../dealInformation/CalculationSettingsInput';
import {getFilters, dealAllowed}                from '@/utilities/DealTypes';
import {addDealWithScenario, getScenarioByDeal} from '@/utilities/LocalStorageActions';
import {TRACE_ERROR}                            from '@/constants';
import reportSingleExecutor                     from "@/components/common/reportSingleExecutor";
import {sortArray}                              from "@/utilities/ArrayUtils";
import scenario                                 from "@/components/scenario";
import { mapGetters }                           from 'vuex';

export default {
  props:    {
    type:       String,
    shownTypes: Array,
    path:       String,
    inputError: String,
    report1:    {
      type:    Object,
      default: () => {
        return {
          pReportName:          null,
          pReportParams:        [],
          flagShowOwnRunButton: false,
          pLabelRunButton:      ''
          //triggerRunReport:     false, // IN DATA!!!
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isOnlineDealsCreationAllowed'
    ]),
    filtersApplied:        function () {
      if (this.filters === undefined && this.shownTypes !== undefined) {
        return getFilters(this.shownTypes);
      } else {
        return this.filters;
      }
    },
    cSelectedScenarioName: function () {
      let res = 'Off';
      if (this.cFlagScenarioSelected) {
        let arr = [this.selectedScenario.data.ScenarioName, this.selectedScenario.data.DealName, this.selectedScenario.data.Vendor];
        arr     = arr.filter(function (e) {
          return e
        });
        res     = arr.join(' / ');
      }
      return res;
    },
    cFlagScenarioSelected: function () {
      return this.selectedScenario && this.selectedScenario.data && this.selectedScenario.data.ScenarioName;
    }
  },
  data() {
    return {
      activityMonth:                  new Date(),
      activityMonths:                 [],
      dealName:                       this.$route.query.dealName,
      dealInfo:                       {},
      collateralInfo:                 {},
      scenarios:                      [],
      selectedScenario:               null,
      userCollCashflows:              [],
      cpr:                            [0],
      cdr:                            [0],
      lossSeverity:                   [0],
      delinquency:                    [0],
      cancel:                         false,
      cancellationDate:               moment(),
      cancellationDateAsDate:         moment().toDate(),
      hpi:                            [],
      NationalUnemploymentForecast:   [],
      hpa:                            [],
      twoYrTsy:                       [],
      tenYrTsy:                       [],
      tuneCpr:                        [1],
      tuneCdr:                        [1],
      tuneSeverity:                   [1],
      mtg15:                          [],
      mtg30:                          [],
      optionalCancellationDateMargin: moment(),
      inputErrorMsg:                  '',
      validDeal:                      false,
      vectors:                        new Map(),
      useLoanLevel:                   this.$store.getters.useLoanLevel || false,
      prepaymentModel:                this.$store.getters.prepaymentModel,
      report1_triggerRunReport:       false,
      report1_reportData:             [],
      flagModalScenarioPickerVisible: false,
    };
  },
  async created() {
    this.$emit('show-spinner');
    this.dealName = this.$route.query.dealName;
    if (dealAllowed(this.dealName, this.filtersApplied)) {
      this.validDeal = true;
      this.$emit('update:validDeal', true);
      await this.populateMainContent();
    }
    //await loadUserCollCashflows(this);
    //await loadScenarios(this);
    //this.selectedScenario = this.populateScenarioByDeal();
    this.$emit('hide-spinner');
  },
  mounted() {
    if (!this.validDeal) {
      this.$refs.dcModalRef.show();
    }
  },
  watch:      {
    inputError(newVal) {
      this.inputErrorMsg = newVal;
    },
    async activityMonth(newVal, oldVal) {
      let newActivityMonth = moment(newVal, 'MM/YYYY');
      const updDate        = moment()
        .year(newActivityMonth.year())
        .month(newActivityMonth.month())
        .date(newActivityMonth.daysInMonth());
      const { data = {} } = await service.getDealDetails(this.dealName, updDate.format('YYYYMMDD'));
      try {
        this.setDealData(data);
      } catch (err) {
        console.log(err);
        this.errorMessage = data || err?.message;
        await service.log(TRACE_ERROR, 'Error occurred during saving deal data', err.stack);
      }
    }
  },
  methods:    {
    onCancellationChangeEmit:     function () {
      this.$emit('cancellationChange', this.cancel);
    },
    onCancellationDateChangeEmit: function () {
      this.$emit('cancellationDateChange', moment(this.cancellationDateAsDate).format('YYYYMMDD'));
    },
    isDisabledCancellationDate(date) {
      return date < this.optionalCancellationDateMargin.toDate();
    },
    populateScenarioByDeal() {
      const populatedScenario = getScenarioByDeal(this.dealName);
      return populatedScenario && populatedScenario.data ? populatedScenario : null;
    },
    async populateMainContent() {
      this.$store.commit('setLastDeal', this.dealName);
      this.$cookies.set('lastCirtDeal', this.dealName, '1d');
      let res = {};
      try {
        res = await service.getUserVectors();
        if (res.status == 200) {
          let vectors = res.data;
          for (let vector of vectors) {
            this.vectors.set(vector.Name, vector.Value.join(','));
          }
        }
        if (this.dealName == '') {
          throw {response: {data: 'Deal file could not be opened'}};
        } else {
          res = await service.get('deals/' + this.dealName);
          this.$store.commit('setDealName', this.dealName);
          this.setDealData(res.data);
          this.activityMonth = this.activityMonths.length > 0
            ? this.activityMonths[0]
            : moment(this.dealInfo.IssueDate, 'MM/DD/YYYY').subtract(1, 'months').format('MM/YYYY');
          this.emitDefaultInputs();
        }
        readCookies(this);
      } catch (err) {
/*
        let res = err.response;
        let msg = res.data.Message || res.data;
        if (msg.match(/Deal file .* could not be opened/g)) {
          if (this.dealName) {
            msg = 'Could not open deal: ' + this.dealName;
          } else {
            msg = 'Wrong path';
          }
          await service.log(TRACE_ERROR, msg, err.stack);
        }
        this.$router.push({
          path:  'error',
          query: {status: res.status, reason: res.statusText, msg: msg}
        });
*/
      }
    },
    emitDefaultInputs() {
      this.$emit('activityMonthChange', this.activityMonth);
      this.$emit('dealNameChange', this.dealName);
      this.$emit('cprChange', this.cpr);
      this.$emit('cdrChange', this.cdr);
      this.$emit('lossSeverityChange', this.lossSeverity);
      this.$emit('delinquencyChange', this.delinquency);
    },
    emit(message, value = '') {
      this.$emit(message, value);
    },
    setDealData(data) {
      data        = formatter.formatDollarValues(data, [
        'CollateralOriginalBalance',
        'CollateralCurrentBalance',
        'CollateralLosses'
      ]);
      data        = formatter.formatDateValues(data, [
        'SettlementDate',
        'IssueDate',
        'MaturityDate',
        'OptionalCancellationDate'
      ]);
      this.cancel = Boolean(data?.Cancellation);
      this.onCancellationChangeEmit(this.cancel);
      this.cancellationDate       = moment(data.OptionalCancellationDate + " 00:00 +0000", "MM/DD/YYYY HH:mm Z");
      this.cancellationDateAsDate = this.cancellationDate.toDate();
      this.onCancellationDateChangeEmit();
      this.optionalCancellationDateMargin = this.cancellationDate;
      data                                = formatter.formatPctValues(data, ['Wac']);
      data['DealFactor']                  = formatter.round(data['DealFactor']);
      data['Wam']                         = formatter.round(data['Wam'], 0);
      data['Wala']                        = formatter.round(data['Wala'], 0);
      this.activityMonths                 = [];
      for (let date of data.DatesOfAvailableUpdates) {
        this.activityMonths.push(formatter.formatDateValue(date, 'MM/YYYY'));
      }
      this.dealInfo       = {
        DealId:                   data.DealId,
        DealType:                 data.DealType,
        SettlementDate:           data.SettlementDate,
        IssueDate:                data.IssueDate,
        OptionalCancellationDate: data.OptionalCancellationDate,
        MaturityDate:             data.MaturityDate
      };
      this.collateralInfo = {
        OriginalBalance:  data.CollateralOriginalBalance,
        CurrentBalance:   data.CollateralCurrentBalance,
        DealFactor:       data.DealFactor,
        WAC:              data.Wac,
        WAM:              data.Wam,
        WALA:             data.Wala,
        CollateralLosses: data.CollateralLosses
      };
    },
    changeDeal(dealName) {
      this.dealName = dealName;
    },
    // Todo: seems unused. Suspicious value assignment.
    onUseLoanLevelChanged(e) {
      this.$store.commit('useLoanLevelChanged', this.useLoanLevel);
    },
    onPrepaymentModelChanged() {
      this.selectedScenario = null;
      this.$emit('scenarioChange', null);
      this.$store.commit('prepaymentModelChanged', this.prepaymentModel);
    },
    setCookies() {
      let type = this.type;
      this.setCookie('cpr', type + 'Cpr');
      this.setCookie('cdr', type + 'Cdr');
      this.setCookie('lossSeverity', type + 'Severity');
      this.setCookie('delinquency', type + 'Delinquency');
      this.setCookie('hpi', type + 'Hpi');
      this.setCookie('NationalUnemploymentForecast', type + 'NationalUnemploymentForecast');
      this.setCookie('hpa', type + 'Hpa');
      this.setCookie('twoYrTsy', type + '2YrTsy');
      this.setCookie('tenYrTsy', type + '10YrTsy');
      this.setCookie('tuneCpr', type + 'TuneCpr');
      this.setCookie('tuneCdr', type + 'TuneCdr');
      this.setCookie('tuneSeverity', type + 'TuneSeverity');
      this.setCookie('mtg15', type + 'Mtg15');
      this.setCookie('mtg30', type + 'Mtg30');
    },
    setCookie(field, cookieName) {
      if (typeof this[field] === 'object') {
        this.$cookies.set(cookieName, JSON.stringify(this[field]), '10d');
      } else if (this[field].length) {
        this.$cookies.set(cookieName, this[field], '10d');
      }
    },
    onScenarioChanged(scenario) {
      addDealWithScenario(this.dealName, scenario);
      this.$emit('scenarioChange', scenario);
    },
    pickerOk(objScenario) {
      this.selectedScenario = null;
      if (objScenario) {
        this.selectedScenario = {
          type: 'scenario',
          data: objScenario
        };
      }
      this.onScenarioChanged(this.selectedScenario)
      this.flagModalScenarioPickerVisible = false;
    }
  },
  components: {
    Datepicker,
    DealCatalog,
    CollateralInformation,
    DealInformation,
    CalculationSettingsInput,
    reportSingleExecutor,
    scenario
  }
};

async function loadScenarios(root) {
  root.scenarios = [];
  let results    = [];
  try {
    let res = await service.getUserScenarios(root.dealName);
    if (res.status == 200) {
      results = results.concat(res.data);
    }
  } catch (err) {
    if (err.response.status != 404) {
      root.inputErrorMsg = err.response.data;
      await service.log(TRACE_ERROR, err.response.data, err.stack);
    }
  }
  try {
    let res = await service.getUserScenarios('Default');
    if (res.status == 200) {
      results = results.concat(res.data);
    }
  } catch (err) {
    if (err.response.status != 404) {
      root.inputErrorMsg = err.response.data;
      await service.log(TRACE_ERROR, err.response.data, err.stack);
    }
  }
  if (results.length > 0) {
    let filteredScenarios = results.filter(s => s.DealName == '' || s.DealName == root.dealName);
    for (let scenario of filteredScenarios) {
      let text = scenario.ScenarioName;
      text +=
        scenario.Vendor == undefined || scenario.Vendor == '' ? '' : ' from ' + scenario.Vendor;
      text +=
        scenario.DealName == undefined || scenario.DealName == ''
          ? ''
          : ' specific for ' + scenario.DealName;
      root.scenarios.push({
        text:  text,
        value: {
          type: 'scenario',
          data: scenario
        }
      });
      root.scenarios = sortArray(root.scenarios, true, 'text');
    }
  }
}

async function loadUserCollCashflows(root) {
  root.userCollCashflows = [];
  let activityMonth      = moment(root.activityMonth, 'MM/YYYY');
  let updDate            = moment()
    .year(activityMonth.year())
    .month(activityMonth.month())
    .date(25);
  try {
    let res = await service.getUserCollateralCashflows(
      root.dealName,
      null,
      formatter.formatAsYYYYMM(updDate)
    );
    if (res.status == 200) {
      for (let userCashflow of res.data) {
        root.userCollCashflows.push({
          text:  userCashflow.ScenarioName,
          value: {
            type: 'cashflow',
            data: userCashflow
          }
        });
      }
    }
  } catch (err) {
    if (err.response.status != 404) {
      root.inputErrorMsg = err.response.data;
      await service.log(TRACE_ERROR, err.response.data, err.stack);
    }
  }
}

function formatData(data) {
  data.ProjectedLosses = formatter.formatDollarValue(data.ProjectedLosses);
  for (let i = 0; i < data.CollateralCashflow.length; i++) {
    data.CollateralCashflow[i] = formatter.formatDateValues(data.CollateralCashflow[i], [
      'PaymentDate'
    ]);
    data.CollateralCashflow[i] = formatter.formatDollarValues(data.CollateralCashflow[i], [
      'Balance',
      'Interest',
      'PassThru',
      'ScheduledPrincipal',
      'PrepaidPrincipal',
      'Defaults',
      'Losses',
      'Recoveries',
      'CumulativeLosses',
      'CumulativeDefaults'
    ]);
    data.CollateralCashflow[i] = formatter.formatPctValues(data.CollateralCashflow[i], [
      'InterestRate',
      'PassThruRate',
      'CprRate',
      'CdrRate'
    ]);
    if (i > 0 && data.CollateralCashflow[i - 1]['Balance'] < 0.005) {
      data.CollateralCashflow = data.CollateralCashflow.slice(0, i);
      break;
    }
  }
  return data;
}

function readCookies(root) {
  let type = root.type;
  readCookie(root, 'cpr', type + 'Cpr', 10);
  readCookie(root, 'cdr', type + 'Cdr', 0.5);
  readCookie(root, 'lossSeverity', type + 'Severity', 20);
  readCookie(root, 'delinquency', type + 'Delinquency');
  readCookie(root, 'NationalUnemploymentForecast', type + 'NationalUnemploymentForecast', '');
  readCookie(root, 'hpa', type + 'Hpa', '');
  readCookie(root, 'twoYrTsy', type + '2YrTsy', '');
  readCookie(root, 'tenYrTsy', type + '10YrTsy', '');
  readCookie(root, 'tuneCpr', type + 'TuneCpr', 1);
  readCookie(root, 'tuneCdr', type + 'TuneCdr', 1);
  readCookie(root, 'tuneSeverity', type + 'TuneSeverity', 1);
  readCookie(root, 'mtg15', type + 'Mtg15', []);
  readCookie(root, 'mtg30', type + 'Mtg30', []);
}

function readCookie(root, field, cookieName, defaultValue = 0) {
  let cookie = [defaultValue];
  if (root.$cookies.isKey(cookieName)) {
    cookie = root.$cookies.get(cookieName);
    try {
      let parsedCookie = JSON.parse(cookie);
      if (typeof parsedCookie === 'object') {
        cookie = parsedCookie;
      }
    } catch (err) {
    }
  }
  root[field] = cookie;
  root.emit(field + 'Change', cookie);
}
</script>

<style lang="scss" scoped>
table {
  &.color {
    margin-bottom: 0;

    th {
      vertical-align: middle;
    }
  }

  &.no-border {
    th,
    td {
      border: none;
    }
  }
}

.form-control {
  font-size: 0.9rem;
  text-align: right;
}

.custom-select {
  border-radius: 0;
}

.no-focus {
  &:focus {
    outline: none;
  }
}
</style>
